import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-due-date-task-return-details-view',
  templateUrl: './due-date-task-return-details-view.component.html',
  styleUrls: ['./due-date-task-return-details-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DueDateTaskReturnDetailsViewComponent implements OnInit {
  @Input() dueDateReturnDetails: any = null;
  constructor() { }

  ngOnInit(): void {
  }

}
